import type { SellerInfo, BuyerInfo } from '@/pages/quotation-design/types';

function InfoRow({ label, value }: { label: string; value: string }) {
  if (!value) return null;
  return (
    <div className="flex items-start gap-3 text-sm">
      <span className="w-20 shrink-0 text-xs text-ink-400">{label}</span>
      <span className="font-medium text-ink-700 leading-snug">{value}</span>
    </div>
  );
}

export default function PartyInfo({
  seller,
  buyer,
}: {
  seller: SellerInfo;
  buyer?: BuyerInfo | null;
}) {
  if (!seller && !buyer) return null;
  const hasBoth = Boolean(seller && buyer);

  return (
    <div className="px-6 md:px-9 mt-7">
      <div
        className={`grid grid-cols-1 ${
          hasBoth ? 'md:grid-cols-2' : ''
        } gap-px bg-ink-100 border border-ink-100 overflow-hidden`}
      >
        {/* Seller */}
        {seller && (
          <div className="bg-cream-50/50 p-5">
            <p className="text-[11px] font-bold tracking-[0.18em] uppercase text-warm-600 mb-3">
              Seller
            </p>
            <div className="space-y-2.5">
              <p className="text-base font-bold text-ink-700">{seller.companyName}</p>
              <InfoRow label="Address" value={seller.address} />
              <InfoRow label="Country" value={seller.country} />
              <InfoRow label="Contact" value={seller.contact} />
              <InfoRow label="Email" value={seller.email} />
              <InfoRow label="Website" value={seller.website} />
            </div>
          </div>
        )}

        {/* Buyer */}
        {buyer && (
          <div className="bg-white p-5">
            <p className="text-[11px] font-bold tracking-[0.18em] uppercase text-ink-500 mb-3">
              Buyer
            </p>
            <div className="space-y-2.5">
              <p className="text-base font-bold text-ink-700">{buyer.companyName}</p>
              <InfoRow label="Contact" value={buyer.contactPerson} />
              <InfoRow label="Address" value={buyer.address} />
              <InfoRow label="Country" value={buyer.country} />
              <InfoRow label="Email" value={buyer.email} />
              <InfoRow label="Phone" value={buyer.phone} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}